import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from "@angular/core";
import {
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonModal,
  IonSearchbar,
  IonTitle,
  IonToolbar,
  SearchbarCustomEvent,
} from "@ionic/angular/standalone";
import { TranslatePipe } from "@ngx-translate/core";
import { SearchableData } from "@shared/modals/searchable-select/searchable-data";

@Component({
  selector: "pa-searchable-select",
  templateUrl: "./searchable-select.component.html",
  styleUrls: ["./searchable-select.component.scss"],
  imports: [
    TranslatePipe,
    IonModal,
    IonHeader,
    IonToolbar,
    IonButton,
    IonTitle,
    IonIcon,
    IonContent,
    IonSearchbar,
    IonItem,
    IonLabel,
  ],
})
export class SearchableSelectComponent implements OnChanges {
  @Input() title!: string;
  @Input() data!: SearchableData[];
  @Input() itemTextField!: string;
  @Input() textCancel = "label.cancel";
  @Output() selectedChanged: EventEmitter<SearchableData> = new EventEmitter();

  @ViewChild("searchbar") searchbar!: IonSearchbar;

  isOpen = false;
  selected!: SearchableData | undefined;
  filtered: SearchableData[] = [];

  onDidPresent(): void {
    this.searchbar.setFocus();
  }

  onDidDismiss(): void {
    this.isOpen = false;
  }

  ngOnChanges(): void {
    this.setFiltered(this.data);
    this.selected = undefined;
  }

  open(): void {
    if (this.data?.length) {
      this.isOpen = true;
      this.setFiltered(this.data);
    }
  }

  cancel(): void {
    this.isOpen = false;
  }

  itemSelected(item: SearchableData): void {
    //reset list of filtered items
    this.setFiltered([]);

    this.selected = item;
    this.selectedChanged.emit(item);
    this.cancel();
  }

  filterItems(event: SearchbarCustomEvent): void {
    const filter = event.detail.value!.toLowerCase();
    this.filtered = this.data.filter((item) => {
      const filterField = item.value;
      return filterField.toLowerCase().includes(filter);
    });
  }

  private setFiltered(data: SearchableData[]): void {
    this.filtered = data;
  }
}
